import { render, staticRenderFns } from "./PartnerClientUpload.html?vue&type=template&id=894fce66&external"
import script from "./PartnerClientUpload.vue?vue&type=script&lang=js"
export * from "./PartnerClientUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports